import React from 'react';
import Layout from 'shared/components/Layout/Layout';
import PasswordReset from 'marketplace/components/Authentication/ForgotPassword/ForgotPassword';

function action({ store }) {
  const { currentUser } = store.getState().subscriptions;

  if (currentUser) {
    return { redirect: '/' };
  }

  return {
    title: 'Tutorfly Password Reset',
    description: 'Recover your Tutorfly password.',
    chunks: ['forgot-password'],
    component: (
      <Layout>
        <PasswordReset />
      </Layout>
    ),
  };
}

export default action;
